import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

export default function ForcastSimulationSuccessAlert(props) {
  const { forecastSimulationSuccessAlert } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  function handleClose() {
    props.handleCloseForcastSimulationSuccessAlert();
  }
  return (
    <Snackbar
      open={forecastSimulationSuccessAlert}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      className={classes.snackbar}
    >
      <MuiAlert
        elevation={6}
        onClose={handleClose}
        severity="success"
        className={classes.alert}
        variant="filled"
      >
        {t('Forecast calculation on going, it might take few minutes')}
      </MuiAlert>
    </Snackbar>
  );
}
